import cn from 'classnames';
import { useState } from 'react';

import Text from 'components/common/Text';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const PaymentCoveredCallout = () => {
  const isTempo = useBrand(TEMPO);

  const [showDetailText, setShowDetailText] = useState(false);
  return (
    <div
      className={cn('mt-2 rounded-xl border border-solid px-4 py-2 text-green-120', {
        'border-green-100 bg-green-40': !isTempo,
        'border-charcoal-60 bg-charcoal-50': isTempo,
      })}
    >
      <Text className={cn({ 'text-green-120': !isTempo, 'text-tempo-blue-120': isTempo })}>
        Your gift card has covered the cost of this box!
      </Text>
      <Text className={cn({ 'text-green-120': !isTempo, 'text-tempo-blue-120': isTempo })}>
        Payment information is not needed until your next order.
      </Text>
      {showDetailText && (
        <div className="mt-2">
          <Text
            className={cn('font-bold', {
              'text-green-120': !isTempo,
              'text-tempo-blue-120': isTempo,
            })}
          >
            How can I add payment information later?
          </Text>
          <Text className={cn({ 'text-green-120': !isTempo, 'text-tempo-blue-120': isTempo })}>
            You can add payment information in Account Settings under Payment Information.
          </Text>
        </div>
      )}
      <Text
        onClick={() => setShowDetailText(!showDetailText)}
        className={cn('mt-2 cursor-pointer underline', {
          'text-green-120': !isTempo,
          'text-tempo-blue-120': isTempo,
        })}
      >
        {showDetailText ? 'Close' : 'Learn more'}
      </Text>
    </div>
  );
};

export default PaymentCoveredCallout;
